<template lang="html">
<div>
  <!-- <v-parallax
    :src="require('../../assets/SocialGames/Background_SMVS.png')"
  > -->
  <v-container fluid pa-0>
    <v-layout>
      <v-flex xs12>
        <v-img :src="require('../../assets/SocialGames/Background_LMS.png')">
          <div class="overall-container">
            <div class="banner-container">
              <!-- <img :src="require('../../assets/SocialGames/Phone_SMVS.png')" class="phone-smv" /> -->
              <v-img
                :src="lmsPhone"
                :max-height="700"
                :max-width="'100%'"
                contain
                :position="'center right'"
              ></v-img>
              <v-container class="parallax-container px-0 more-styling">
                <v-layout>
                  <v-flex xs12 sm8 md6 lg5 xl4 class="text-xs-left">
                    <v-img
                      :src="lmsIcon"
                      :max-width="'30%'"
                      aspect-ratio="1"
                      contain
                      :position="'center left'"
                    ></v-img>
                    <h1 class="about-title text-xs-left">Lobstermania Slots<sup>&trade;</sup></h1>
                    <h4 class="about-subtitle text-xs-left">Winner Winner Lobster Dinner!</h4>

                    <v-flex xs12 sm12 md12 lg12 xl10 class="text-xs-left">
                      <p class="body-text text-xs-left">Spin the reels to play "Lobstermania", "Stinkin' Rich Hot Poker Dice" &amp; all your favorite REAL VEGAS slot games; each packed with unique features, HUGE PAYOUTS & fun gameplay!</p>
                      <!-- <v-img
                        :src="smvButton"
                        @click="smvClick"
                        @mouseenter="changeButton"
                        @mouseleave="defaultButton"
                        id="smvBtn"
                      ></v-img> -->
                      <v-layout row>
                        <v-flex xs6 sm12 md12 lg12>
                          <a class="storeLinks" href="https://lobstermania-slots.onelink.me/PRsr?utm_source=ksg_web&utm_medium=website_click&utm_campaign=ksg_webtolmsapp&utm_content=playforfreebutton&utm_term=all_users&pid=ksg_web&c=ksg_webtolmsapp&af_dp=com.ksgmobileinc.lobstermaniaslots" style="display:inline-block; width: 100%; height: 100%;" target="_blank" id="iosBtn"><v-img :src="iosStore" contain></v-img></a>
                        </v-flex>

                        <v-flex xs6 sm12 md12 lg12>
                          <a class="storeLinks" href="https://lobstermania-slots.onelink.me/PRsr?utm_source=ksg_web&utm_medium=website_click&utm_campaign=ksg_webtolmsapp&utm_content=playforfreebutton&utm_term=all_users&pid=ksg_web&c=ksg_webtolmsapp&af_dp=com.ksgmobileinc.lobstermaniaslots" style="display:inline-block; width: 100%; height: 100%;" target="_blank" id="googleBtn"><v-img :src="googlePlay" contain ></v-img></a>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </div>
        </v-img>
      </v-flex>
    </v-layout>
  </v-container>
  <!-- </v-parallax> -->

  <v-container class="smv-container">
    <v-layout justify-center>
      <v-flex xs12 sm8 md8 lg6 xl6>
        <hr>
        <h3 class="text-xs-left" style="margin: 1rem 0;">Video Preview</h3>
        <div class="iframe-container">
          <iframe
            width="480"
            height="345"
            src="https://www.youtube.com/embed/5s0iqJvgeh8?utm_source=LMSWebSite&utm_medium=lms_website_web&utm_campaign=Persistent"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            >
          </iframe>
        </div>

        <hr style="margin-top: 1rem;">
        <h3 class="text-xs-left" style="margin: 1rem 0;">Screenshots</h3>
        <div class="screenshots-container">
          <div class="horizontal-scroll">
            <v-img v-for="(image, i) in screenshots"
              :src="image"
              :max-height="400"
              :key="i"
              contain
            ></v-img>
            <!-- <v-img
            src="https://picsum.photos/350/165?random"
            class="grey darken-4"
            ></v-img>
            <v-img
            src="https://picsum.photos/350/165?random"
            class="grey darken-4"
            ></v-img>
            <v-img
            src="https://picsum.photos/350/165?random"
            class="grey darken-4"
            ></v-img>
            <v-img
            src="https://picsum.photos/350/165?random"
            class="grey darken-4"
            ></v-img>
            <v-img
            src="https://picsum.photos/350/165?random"
            class="grey darken-4"
            ></v-img>
            <v-img
            src="https://picsum.photos/350/165?random"
            class="grey darken-4"
            ></v-img> -->
          </div>
        </div>

        <hr style="margin-top: 1rem;">
        <h3 class="text-xs-left" style="margin: 1rem 0;">App Description</h3>
        <p class="text-xs-left">Introducing the ALL-NEW Lobstermania Slots, the ultimate free to play Vegas casino experience! &nbsp;Immerse yourself in the electrifying world of our captivating slot machines, bringing the essence of Las Vegas slots directly to your mobile device.</p>
        <p class="text-xs-left">Dive into the glitz and glam of Vegas right from your phone with our free to play slots! &nbsp;Experience the thrill of classic casino hits like Lucky Larry’s Lobstermania, where the promise of colossal wins awaits, or opt for a dash of humor (and wealth!) with Stinkin Rich HPD. &nbsp;We've got all your favorite Vegas-style slots with bonus games, free spins, and massive jackpots waiting to be hit. &nbsp;Choose from your favorite slots like Super Sally’s Shrimpmania, Dragons vs Pandas, Fishing Bob, and much more! Download today and start playing for free!</p>
        <p class="text-xs-left">Discover a Diverse World of Casino Slots<br>Explore a rich selection of casino slots that redefine the mobile gaming experience. &nbsp;Lobstermania Slots goes beyond a standard mobile casino, delivering a social casino where players unite to enjoy the thrill of spinning reels and pursuing colossal jackpots and wins.</p>
        <p class="text-xs-left">Engage in the excitement of our carefully curated slot machines, each crafted to transport you to the heart of casino action. &nbsp;From classic Vegas slots to cutting-edge video slots, our mobile casino ensures every player finds their perfect slot match, chasing those elusive huge jackpots.</p>
        <p class="text-xs-left">Elevate Your Experience with Social Casino Interaction<br>Lobstermania Slots is more than just a platform for casino slot machines; it's a vibrant social hub where players connect, compete, and share the excitement of victory. &nbsp;Participate in thrilling slot tournaments, forging bonds with friends and fellow players while raising the stakes in the social casino realm and competing for impressive jackpots.</p>
        <p class="text-xs-left">Bingo Slots: A Fusion of Bingo and Slots<br>Embark on an adventure with our innovative bingo slots, blending the best of both worlds. &nbsp;Immerse yourself in an interactive and novel gaming experience, marking off numbers on your way to extraordinary wins and unexpected jackpots. &nbsp;Lobstermania Slots takes traditional gameplay to new heights.</p>
        <p class="text-xs-left">Online Vegas Slot Machines: The Allure of Vegas, Anywhere<br>Lobstermania Slots captures the essence of Vegas slots, offering the convenience of online play. &nbsp;Experience the thrill of spinning the reels on our online Vegas slot machines, bringing the magic of the iconic strip directly to your personal space. &nbsp;Discover a world where online Vegas slot machines lead to big jackpots.</p>
        <p class="text-xs-left">Mobile Casino Convenience: Play Anytime, Anywhere<br>Adapting to the mobile casino revolution, Lobstermania Slots ensures that your favorite casino slots are accessible 24/7. &nbsp;Whether you're at home or on the move, the allure of our mobile casino is just a quick tap away. &nbsp;Brace yourself for a seamless and immersive gaming experience on your mobile device, where you can chase hot jackpots wherever you go.</p>
        <p class="text-xs-left">In the dynamic realm of social casino gaming, Lobstermania Slots stands as a beacon for those seeking free-to-play excitement and the thrill of jackpots. &nbsp;Our casino slot machines redefine entertainment, providing an online Vegas experience with the added charm of social interaction and the chance for incredible jackpots.</p>
        <p class="text-xs-left">Download Lobstermania Slots today and be among the first to experience this revolutionary social casino experience! &nbsp;Explore hundreds of captivating Las Vegas slots, discover innovative new features, and see why Lobstermania Slots is the ultimate destination for free-to-play slot enthusiasts. &nbsp;Experience the magic of our social casino floor and groundbreaking bingo slots and tournaments. &nbsp;Whether you're a seasoned player or new to the casino scene, Lobstermania Slots offers an unforgettable adventure filled with endless possibilities. &nbsp;Spin, play, and chase those incredible jackpots – your Vegas awaits!</p>
        <p class="text-xs-left">#LobstermaniaSlots #Lobstermania #LobstermaniaSlotsCasino #LobstermaniaBigPayouts</p>
        <p class="text-xs-left">#LobstermaniaFreeBonus #LobstermaniaJackpots #LuckyLarry #Lobstermania #GhostIsland</p>
        <p class="text-xs-left">#FishingBob #PrinceOfThieves #PhoneTag #StateFair #ShowMeVegasSlots #VegasSlots #FavoriteVegasSlots</p>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
export default {
  data () {
    return {
      googlePlay: require('../../assets/buttons/Button_GooglePlayEnabled-smv.png'),
      iosStore: require('../../assets/buttons/Button_AppStoreEnabled-smv.png'),
      smvFacebook: require('../../assets/buttons/Button_FindUsEnabled.png'),
      lmsIcon: require('../../assets/LobsterManiaSlotsLogo.png'),
      smvButton: require('../../assets/buttons/Button_PlayForFreeEnabled.png'),
      smvHover: require('../../assets/buttons/Button_PlayForFreeOver.png'),
      lmsPhone: require('../../assets/SocialGames/Phone_LMS.png'),
      screenshots: [
        require('../../assets/AppScreenshots/LMS/SellingPoint_2208x1242_1.png'),
        require('../../assets/AppScreenshots/LMS/RealCasinos_2208x1242_2.png'),
        require('../../assets/AppScreenshots/LMS/DailyBonus_2208x1242_3.png'),
        require('../../assets/AppScreenshots/LMS/Entertainment_2208x1242_4.png'),
        require('../../assets/AppScreenshots/LMS/GenericSlotMixAlt_2208x1242_5.png'),
        require('../../assets/AppScreenshots/LMS/HotBingo_2208x1242_6.png'),
        require('../../assets/AppScreenshots/LMS/Tournaments_2208x1242_7.png'),
        require('../../assets/AppScreenshots/LMS/ProgressiveJackpot_2208x1242_8.png'),
        require('../../assets/AppScreenshots/LMS/LobstermaniaSlots_2208x1242_9.png'),
        require('../../assets/AppScreenshots/LMS/BonusGame_2208x1242_10.png')
      ]
    }
  },
  computed: {
    mobile () {
      return navigator.userAgent.toLowerCase().indexOf('iphone') > -1 || navigator.userAgent.toLowerCase().indexOf('android') > -1
    },
    ipad () {
      return navigator.userAgent.toLowerCase().indexOf('ipad') > -1
    }
  },
  methods: {
    // smvClick () {
    //   window.open('https://showmevegasslots.onelink.me/uBTP?promoLink=UmMlkY2Q4dYjMkW7&utm_source=KSGWebSite&utm_medium=ksg_website_web&utm_campaign=Persistent%2Cwebsite_connect%2CNULL%2CNULL&utm_content=NULLApp_Button&utm_term=G1%2CV0%2CNULL%2CR0%2C&af_dp=com.ksgmobileinc.showmevegasslotsv2%3A%2F%2F', '_blank')
    // },
    changeButton (term) {
      let termArr = term.split('-')
      let platform = termArr[0]
      let el = document.querySelector(`#${platform}Btn`)
      let image = this[termArr[1]]
      el.src = image
      el.srcset = image
      // let el = document.querySelector(`#smvBtn div.v-image__image--cover`)
      // el.style.backgroundImage = 'url(' + this.smvHover + ')'
    },
    defaultButton (term) {
      let termArr = term.split('-')
      let platform = termArr[0]
      let el = document.querySelector(`#${platform}Btn`)
      let image = this[termArr[1]]
      el.src = image
      el.srcset = image
      // let el = document.querySelector(`#smvBtn div.v-image__image--cover`)
      // el.style.backgroundImage = 'url(' + this.smvButton + ')'
    }
  }
}
</script>

<style lang="css" scoped>
.parallax-container {
  /* width: 35%; */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  /* justify-content: center; */
}

.smv-container {
  /* width: 35%; */
  /* margin: 0; */
}

.screenshots-container {
  display: grid;
  grid-template-columns: 5px 1fr 5px;
}

.screenshots-container > * {
  grid-column: 2 / -2;
}

.screenshots-container > .full {
  grid-column: 1 / -1;
}

.horizontal-scroll {
  display: grid;
  grid-gap: 10px;
  /* grid-template-columns: repeat(8, calc(50% - 40px)); */
  grid-template-columns: repeat(10, 90%);
  grid-template-rows: minmax(200px, 1fr);
  overflow-x: scroll;
}

.overall-container {
  height: 100%;
}

.banner-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  height: 100%;
  padding: 1rem;
  grid-gap: 2rem;
}

.phone-smv {
  background-size: cover;
  display: grid;
  place-self: end;
  height: 90%;
  align-self: center;
}

.gameImg {
  /* width: 128px;
  height: 128px; */
}

.more-styling {
  /* width: 40%;
  margin: 0;
  margin-left: 1rem; */
  color: white;
}

.about-title {
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: -1px;
  line-height: 99%;
  margin-bottom: 0.5rem;
}

.about-subtitle {
  /* font-size: 2rem; */
  font-weight: 800;
  /* letter-spacing: -1px; */
  line-height: 99%;
  margin-bottom: 1rem;
}

.iframe-container {
  position: relative;
  width: 100%;
  padding-bottom: 60%;
  height: 0;
}

.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

sup {
  vertical-align: sub;
}
</style>
